'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRedux = require('react-redux');

var _profile = require('redux/modules/profile');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// methods used for redux

var MyProfile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data
  };
}, { updateProfile: _profile.update }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MyProfile, _Component);

  function MyProfile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MyProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyProfile.__proto__ || (0, _getPrototypeOf2.default)(MyProfile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      parentName: _this.props.profile.parentName || '',
      isEdit: false
    }, _this.handleClickEdit = function () {
      var obj = _this.state;
      obj.isEdit = !obj.isEdit;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = {};
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleSave = function () {
      var userId = _this.props.user.userId;
      _this.props.updateProfile(userId, _this.state);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* ****************************** */
  /* HANDLE FORM CHANGE FUNCTIONS   */
  /* ****************************** */

  // without handleChange, form value fields would not change on the front end


  (0, _createClass3.default)(MyProfile, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card },
            _react2.default.createElement(
              'div',
              { className: styles.cardContent },
              _react2.default.createElement(
                'h2',
                { className: styles.orangeText + ' ' + styles.textCenter },
                'My profile'
              ),
              _react2.default.createElement(
                'h4',
                { className: styles.greenText },
                'Name: ',
                _react2.default.createElement(
                  'span',
                  { className: styles.normalText },
                  this.state.parentName
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.ButtonToolbar,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'pull-right',
                    bsStyle: 'success', onClick: this.handleClickEdit },
                  _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                  '  Edit profile'
                )
              )
            )
          )
        ),
        this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My profile'
            ),
            _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { bsStyle: 'success', className: 'pull-right', onClick: function onClick() {
                    _this2.handleClickEdit();_this2.handleSave();
                  } },
                _react2.default.createElement('i', { className: 'fa fa-check' }),
                '  Save'
              )
            )
          )
        )
      );
    }
  }]);
  return MyProfile;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateProfile: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = MyProfile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/MyProfile.js
// module id = 1226
// module chunks = 0